import { render, staticRenderFns } from "./OpeningBalances2.vue?vue&type=template&id=6b2d9fda&"
import script from "./OpeningBalances2.vue?vue&type=script&lang=js&"
export * from "./OpeningBalances2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports